<template>
  <div>
    <div class="banner">Coming soon! Please check back later!</div>
    <b-row no-gutters class="template-one">
      <!-- Left content column -->
      <b-col cols="12" md="6" xl="4" class="content-column">
        <div class="content-wrapper">
          <img :src="logo" alt="logo" class="logo" />
          <h1 class="title">{{ title }}</h1>
          <vue-typed-js class="disclaimer" :loop="true" :strings="disclaimer">
            <span class="typing"></span>
          </vue-typed-js>
          <p class="email">contact@superkocards.com</p>
        </div>
      </b-col>

      <!-- Right image grid -->
      <b-col cols="12" lg="6" xl="8" class="background-container">
        <div class="image-grid">
          <div
            v-for="(image, index) in gridImages"
            :key="index"
            class="grid-item"
          >
            <img
              :src="image"
              :alt="`Grid image ${index + 1}`"
              class="grid-image"
            />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "TemplateOne",
  data() {
    return {
      logo: require("@/assets/logo.png"),
      title: "Super Ko Trading Cards",
      disclaimer: [
        "Our website is under construction.",
        "We'll be here soon with our new store!",
        "Check back soon!",
      ],
      gridImages: Array.from({ length: 6 }, (_, i) =>
        require(`@/assets/grid${i + 1}.webp`)
      ),
    };
  },
};
</script>

<style lang="scss" scoped>
.banner {
  background-color: #4caf50;
  color: white;
  text-align: center;
  padding: 0.5rem;
  font-weight: bold;
  font-size: 1.2rem;
}

.template-one {
  min-height: 100vh;

  .content-column {
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content-wrapper {
    text-align: center;
  }

  .logo {
    max-width: 350px;

    @media (max-width: 768px) {
      max-width: 200px;
    }
  }

  .title {
    font-size: 2rem;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .disclaimer {
    font-size: 1.25rem;
    font-weight: 300;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }

  .email {
    font-size: 1rem;
    color: #666;
    padding-top: 5px;
  }

  .background-container {
    background-color: #003a5d;
    box-shadow: inset 0 0 5rem rgba(0, 0, 0, 0.2);
    padding: 3rem;
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
      padding: 2rem;
    }
  }

  .image-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    width: 100%;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 2rem;
    }
  }

  .grid-item {
    aspect-ratio: 1;
    overflow: hidden;
    border-radius: 1rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: inherit;
      transition: transform 0.3s;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
</style>
